import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { isAuthenticated, getTokens } from '../api/identity';
import { getUserById } from '../api/user';
import SubscriptionGate from './SubscriptionGate';
import { UserSubscriptionStatus } from '../types/user.types';

const RequireAuth: React.FC<{ children: React.ReactElement }> = ({
  children,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [subscriptionStatus, setSubscriptionStatus] =
    useState<UserSubscriptionStatus | null>(null);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const checkAuthAndSubscription = async () => {
      const tokens = getTokens();
      if (!tokens || !isAuthenticated()) {
        console.log('Not authenticated, redirecting to login');
        navigate('/login');
        return;
      }

      try {
        // Get user ID from localStorage
        const userId = localStorage.getItem('userId');
        if (!userId) {
          navigate('/login');
          return;
        }

        // Fetch user data to check subscription status
        const user = await getUserById(parseInt(userId));
        if (user) {
          setSubscriptionStatus(user.subscriptionStatus);
          setUser(user);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthAndSubscription();
  }, [navigate]);

  // Show loading state
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-violet-600"></div>
      </div>
    );
  }

  if (
    subscriptionStatus === UserSubscriptionStatus.TRIAL_EXPIRED &&
    user.onboarded
  ) {
    return <SubscriptionGate>{children}</SubscriptionGate>;
  }

  return children;
};

export default RequireAuth;
